module.exports = __webpack_public_path__ + "static/Dirha-cover-f8849a25f67e2a2e8f58936689089234.jpg";